import { Loader } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

interface ButtonProps {
  buttonText: string;
  width?: string | number;
  padding?: string;
  text?: string;
  handleIsModelOpen?: () => void; // Should be a function, not boolean
  handleConfirmDeleteModel?: (id: number) => Promise<void>; // Assuming API call
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  buttonText,
  width,
  padding = "p-[10px] xxl:p-[20px]",
  text = "text-sm",
  handleIsModelOpen,
  onClick,
  type = "submit",
  isLoading = false,
}) => {
  const loadingGlobal = useSelector((state: any) => state?.General);

  return (
    <button
      type={type}
      className={`gradient-button ${padding} rounded-[5px] ${text}`}
      style={{ width }}
      onClick={onClick || handleIsModelOpen} // Allows both onClick and handleIsModelOpen
    >
      {loadingGlobal?.isLoading && isLoading ? (
        <Loader
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        />
      ) : (
        buttonText
      )}
    </button>
  );
};

export default Button;
